import { api } from "./index";

export interface MainWallet {
    main_wallet: string;
    alny_wallet: string;
    alny_wallet_pending: string;
    main_garant_wallet: string;
    main_future_wallet: string;
    main_future_charity_wallet: string;
    main_future_estate_wallet: string;
    main_future_star_wallet: string;
    main_pending_withdrawal: string;
    withdrawal_destination: string;
    main_monthly_profit: string;
    main_transit_wallet: string;
    total_deposited: string;
    total_earned: string;
    total_spent: string;
    total_withdrawn: string;
}

export interface CryptoWallet {
    usdt_wallet: string;
    usdt_debt_wallet: string;
    usdt_garant_wallet: string;
    usdt_future_wallet: string;
    usdt_future_charity_wallet: string;
    usdt_future_estate_wallet: string;
    usdt_future_star_wallet: string;
    usdt_pending_withdrawal: string;
    usdt_monthly_profit: string;
    usdt_transit_wallet: string;
    usdt_total_deposited: string;
    usdt_total_earned: string;
    usdt_total_spent: string;
    usdt_total_withdrawn: string;
}

export interface CharityWallet {
    total_earned: string;
    usdt_earned: string;
    current_month: string;
}

export interface StripeCard {
    id: number;
    card_mask: string;
    card_type: string;
    count: number;
}

export interface PayzeCard {
    id: number;
    card_number: string;
    card_holder: string;
    amount: number;
    status: string;
}

export interface Cards {
    stripe_cards: StripeCard[];
    payze_cards: PayzeCard[];
}

export interface InvestmentProgram {
    is_participant: boolean;
    active_money: string;
    total_earned: string;
}

export interface StarProgram {
    is_participant: boolean;
    total_earned: string;
    total_withdrawn: string;
    user_total: number;
    register_date: string;
    pay_date: string;
}

export interface EstateProgram {
    is_participant: boolean;
    total_earned: string;
    debts_count: number;
}

export interface Programs {
    investment: InvestmentProgram;
    star: StarProgram;
    estate: EstateProgram;
}

export interface UserInfo {
    id: number;
    name: string;
    surname: string;
    email: string;
    email_verified_at: string | null;
    mobile: string;
    inviter_id: number;
    telegram_id: string;
    telegram_username: string;
    telegram_bot: string;
    passport: string | null;
    rank: number;
    status: string;
    status2: string;
    status3: string | null;
    partner_status: number;
    pack: number;
    pack_time: string;
    secret_cookie: string;
    ref_miss: string | null;
    is_dealer: boolean;
    dealer_time: string | null;
    is_manager: boolean;
    manager_time: string | null;
    manager_deact_time: string | null;
    country: string;
    sex: number;
    date_of_birth: string;
    city: string | null;
    address: string;
    bank_account: string;
    bank_swift: string;
    bank_card: string | null;
    bep20: string;
    trc20: string;
    photo: string;
    instagram: string;
    facebook: string;
    sponsor: string | null;
    account_type: number;
    is_blocked: boolean;
    is_active: string | null;
    member_fee_time: string | null;
    register_date_game: string | null;
    ref_link: string;
    country_referrals: string;
    structure_status: number;
    charity_status: number;
    estate_status: number;
    star_year_status: number;
    star_join_date: number;
    garant_out: number;
    garant_in: number;
    garant_positive: number;
    garant_negative: number;
    silver_patron_amount: number;
    silver_patron_time: string | null;
    gold_patron_amount: number;
    gold_patron_time: string | null;
    gold_immunity: number;
    gold_misses: number;
    gold_lost: boolean;
    can_invest: boolean;
    invest_auth_url: string | null;
    invest_garant: boolean;
    language: string;
    autopay: boolean;
    stripe_customer_id: string;
    show_graphs: boolean;
    last_login: string;
    last_chance_used: string | null;
    last_chance_comments: string | null;
    roles: string[];
    heir_name: string;
    heir_surname: string;
    heir_passport: string;
    heir_dob: string;
    created_at: string;
    updated_at: string;
    programs: {
        charity: number;
        star: number | null;
        marathon: number | null;
        marketplace: number | null;
        millenium: number | null;
    };
    programs_data: {
        charity_tickets: number;
        marathon_tickets: number;
        star_tickets: number;
    };
}

export interface StarProgramData {
    user_id: number;
    sponsors: string[];
    levels: number[];
    user_total: number;
    user_register_date: string;
    user_pay_date: string;
}

export interface UserStats {
    clients_total: number;
    clients_month: number;
    dillers_total: number;
    dillers_month: number;
    managers_total: number;
    managers_month: number;
    charity_spent: number;
    charity_earned_month: number;
    charity_earned_month_usdt: number;
    charity_participations_total: number;
    charity_participations_month: number;
    charity_earned_total: number;
    charity_coeff: string;
    estate_spent: number;
    estate_earned_month: number;
    estate_earned_month_usdt: number;
    estate_participations_total: number;
    estate_participations_month: number;
    estate_earned_total: number;
    estate_coeff: number;
    star_earned_month: number;
    star_earned_month_usdt: number;
    star_earned_total: number;
    star_users_total: number;
    star_withdrawn_total: number;
    shares_count: number;
    shares_earned_month: string;
    shares_earned_month_usdt: string;
    shares_earned_total: string;
    shares_earned_total_usdt: string;
    level_counts: number[];
    new_referrals_count: number;
    total_referrals: number;
    total_referrals_month: number;
    companies_earned_month: string;
    companies_total: number;
    companies_month: number;
    companies_earned_total: string;
    pack_duration_months: number;
    spam_count: number;
    spam_fine_until: string | null;
    spam_next_ban_duration: number;
    should_logout: boolean;
    timer_0: string;
    timer_1: string;
    left_timer_0: string;
    left_timer_1: string;
    est_timer_0: string;
    est_timer_1: string;
}

export interface InvestmentData {
    alny_invest_id: number;
    total_invested: number;
    total_earned: number;
    active_investments: number;
    completed_investments: number;
}

export interface EstateData {}

export interface WalletRaw {
    user_id: number;
    main_wallet: string;
    alny_wallet: string;
    alny_wallet_pending: string;
    main_garant_wallet: string;
    main_future_wallet: string;
    main_future_charity_wallet: string;
    main_future_estate_wallet: string;
    main_future_star_wallet: string;
    main_pending_withdrawal: string;
    withdrawal_destination: string;
    main_monthly_profit: string;
    main_transit_wallet: string;
    total_deposited: string;
    total_earned: string;
    total_spent: string;
    total_withdrawn: string;
    usdt_wallet: string;
    usdt_debt_wallet: string;
    usdt_garant_wallet: string;
    usdt_future_wallet: string;
    usdt_future_charity_wallet: string;
    usdt_future_estate_wallet: string;
    usdt_future_star_wallet: string;
    usdt_pending_withdrawal: string;
    usdt_monthly_profit: string;
    usdt_transit_wallet: string;
    usdt_total_deposited: string;
    usdt_total_earned: string;
    usdt_total_spent: string;
    usdt_total_withdrawn: string;
    money_safe: string;
    money_safe_work: string;
    last_transfer_at: string | null;
    should_update_card_info: boolean;
    is_withdrawal_to_russian_card_enabled: boolean;
    created_at: string;
    updated_at: string;
}

export interface WalletData {
    main_wallet: MainWallet;
    crypto_wallet: CryptoWallet;
    charity_wallet: CharityWallet;
    cards: Cards;
    programs: Programs;
    user: UserInfo;
    user_stats: UserStats;
    star_program?: StarProgramData;
    investment_data?: InvestmentData;
    estate_data?: EstateData | null;
    wallet_raw?: WalletRaw;
}

export interface WalletResponse {
    success: boolean;
    data: WalletData;
}

export interface WithdrawRequest {
    amount: number;
    currency: string;
    where_withdraw?: string;
}

export interface TransferRequest {
    recipient_id: string;
    amount: number;
    currency: string;
    telegram_code: number;
    recipient_name: string;
    is_guarantee?: boolean;
    guarantee_description?: string;
}

export interface SendTelegramCodeRequest {
    recipient_id: string;
    amount: number;
    currency: string;
    recipient_name: string;
}

export interface RaiseStatusRequest {
    currency: number;
}

export interface ExchangeRequest {
    from_currency: number;
    to_currency: number;
    amount: number;
}

export interface PayMembershipRequest {
    currency: number;
    type: number;
}

export interface PayStarProgramRequest {
    user_id: number;
    currency: string;
    month: number;
    type: string;
    id: number;
    time_to_pay: null;
}

export interface TopUpMethod {
    type: number;
    name: string;
    description: string;
    available: boolean;
    currency: string;
}

export interface TopUpMethodsResponse {
    success: boolean;
    data: {
        methods: TopUpMethod[];
    };
}

export interface CreateTopUpRequest {
    amount: number;
    type: number;
    description?: string;
}

export interface CreateTopUpResponse {
    success: boolean;
    message: string;
    data: {
        payment_id: number;
        invoice_id?: string;
        amount: string;
        pay_url?: string;
        status: string;
        type: number;
        description?: string;
        amount_usdt?: number;
        amount_rub?: number;
        who?: string;
        wallet_address?: string;
        network?: string;
    };
}

export interface TopUpHistoryItem {
    id: number;
    type: string;
    amount: string;
    status: string;
    created_at: string;
    paid_at: string | null;
    description: string;
}

export interface TopUpHistoryResponse {
    success: boolean;
    data: {
        current_page: number;
        data: TopUpHistoryItem[];
        total: number;
        per_page: number;
        last_page: number;
    };
}

export interface TopUpStatusResponse {
    success: boolean;
    data: {
        id: number;
        type: string;
        amount: string;
        status: string;
        created_at: string;
        paid_at: string | null;
        description: string;
        pay_url?: string;
        amount_usdt?: number;
        amount_rub?: number;
        who?: string;
    };
}

export interface PendingCardPayment {
    id: number;
    user_id: number;
    user_name: string;
    user_telegram: string;
    sum: number;
    sum_load: number;
    sum_tether: number;
    receiver: number;
    receiver_name: string;
    receiver_tel: string;
    receiver_hash: string;
    type: number;
    hash: string;
    address: string;
    strategy: number;
    time: number;
    created_at: string;
    amount_rub?: number;
    amount_usdt?: number;
}

export interface PendingCardPaymentsResponse {
    success: boolean;
    data: {
        payments: PendingCardPayment[];
    };
}

export interface ConfirmCardPaymentRequest {
    payment_id: number;
    confirmation_code: string;
}

export interface BalanceInfo {
    balance_rub: number;
    balance_usdt: number;
    deposit_address: string;
}

export interface BalanceInfoResponse {
    success: boolean;
    data: BalanceInfo;
}

export interface UpdateDepositAddressRequest {
    address: string;
}

export interface ConfirmCryptoPaymentRequest {
    wallet_address: string;
    amount: number;
}

export interface AdminRussiaPendingPayment {
    id: number;
    user_id: number;
    user_name: string;
    amount_rub: number;
    amount_usdt: number;
    receiver: number;
    receiver_tel: string;
    receiver_name: string;
    status: number;
    created_at: string;
}

export interface AdminRussiaPendingResponse {
    success: boolean;
    data: {
        payments: AdminRussiaPendingPayment[];
    };
}

export interface CreateRussiaHandRequest {
    user_id: number;
    who: string;
    description?: string;
    receiver_tel?: string;
    telegram_username?: string;
    working_hours?: string;
    payment_methods?: PaymentMethod[];
    sum: number;
    sum_tether: number;
    sum_total: number;
    status: boolean;
}

export interface UpdateRussiaHandRequest {
    user_id?: number;
    who?: string;
    description?: string;
    receiver_tel?: string;
    telegram_username?: string;
    working_hours?: string;
    payment_methods?: PaymentMethod[];
    sum?: number;
    sum_tether?: number;
    sum_total?: number;
    status?: boolean;
}

export interface PaymentMethod {
    bank?: string;
    card_number?: string;
    type?: string;
    comment?: string;
}

export interface RussiaHand {
    alny_russia_hands_id: number;
    alny_russia_hands_user_id: number;
    who: string;
    description: string | null;
    receiver_tel: string | null;
    telegram_username?: string | null;
    working_hours?: string | null;
    payment_methods?: PaymentMethod[] | null;
    alny_russia_hands_sum: number;
    alny_russia_hands_sum_tether: number;
    alny_russia_hands_sum_total: number;
    status: boolean;
    created_at: string;
    updated_at: string;
}

export interface RussiaHandsResponse {
    success: boolean;
    data: RussiaHand[];
}

export interface RussiaHandResponse {
    success: boolean;
    data: RussiaHand;
}

export interface HandlerPendingPayment {
    id: number;
    user_id: number;
    user_name: string;
    amount_rub: number;
    amount_usdt: number;
    status: number;
    created_at: string;
}

export interface HandlerPendingPaymentsResponse {
    success: boolean;
    data: {
        handler_name: string;
        pending_payments: HandlerPendingPayment[];
    };
}

export interface HandlerBalanceInfo {
    handler_name: string;
    balance_rub: number;
    balance_usdt: number;
}

export interface HandlerBalanceInfoResponse {
    success: boolean;
    data: HandlerBalanceInfo;
}

export interface ConfirmHandlerPaymentRequest {
    payment_id: number;
    confirmation_code: string;
}

export interface ConfirmHandlerPaymentResponse {
    success: boolean;
    message: string;
}

export interface TransactionRecord {
    id: number;
    time: string;
    type: number;
    type2: number;
    currency: number;
    desc: string;
    additional_desc: string;
    sum: number;
    total: number;
    currency_symbol: string;
    type_icon: string;
}

export interface PaginationInfo {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

export interface UserStatsResponse {
    success: boolean;
    data: {
        records: TransactionRecord[];
        pagination: PaginationInfo;
    };
}

export interface SummaryStats {
    total_income: number;
    total_expense: number;
    current_balance: number;
    transactions_count: number;
    last_transaction: string;
}

export interface SummaryStatsResponse {
    success: boolean;
    data: SummaryStats;
}

export interface CurrencyStats {
    income: number;
    expense: number;
    balance: number;
}

export interface CurrencyStatsResponse {
    success: boolean;
    data: {
        usd: CurrencyStats;
        usdt: CurrencyStats;
    };
}

const walletApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getWalletInfo: builder.query<WalletData, void>({
            query: () => "/wallet/info",
            providesTags: [{ type: "WalletInfo", id: "CURRENT" }],
            keepUnusedDataFor: 60,
        }),
        withdraw: builder.mutation<{ success?: boolean }, WithdrawRequest>({
            query: (body) => ({
                url: "/wallet/withdraw",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "WalletInfo", id: "CURRENT" }],
        }),
        sendTelegramCode: builder.mutation<{ success?: boolean }, SendTelegramCodeRequest>({
            query: (body) => ({
                url: "/telegram/send-code",
                method: "POST",
                body,
            }),
        }),
        transfer: builder.mutation<{ success?: boolean }, TransferRequest>({
            query: (body) => ({
                url: "/wallet/transfer",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "WalletInfo", id: "CURRENT" }],
        }),
        raiseStatus: builder.mutation<{ success?: boolean }, RaiseStatusRequest>({
            query: (body) => ({
                url: "/wallet/raise-status",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "WalletInfo", id: "CURRENT" }],
        }),
        exchange: builder.mutation<{ success?: boolean }, ExchangeRequest>({
            query: (body) => ({
                url: "/wallet/exchange",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "WalletInfo", id: "CURRENT" }],
        }),
        payMembership: builder.mutation<{ success?: boolean }, PayMembershipRequest>({
            query: (body) => ({
                url: "/wallet/pay-membership",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "WalletInfo", id: "CURRENT" }],
        }),
        payStarProgram: builder.mutation<{ success?: boolean }, PayStarProgramRequest>({
            query: (body) => ({
                url: "/pay",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "WalletInfo", id: "CURRENT" }],
        }),
        getTopUpMethods: builder.query<TopUpMethod[], void>({
            query: () => "/topup/methods",
            providesTags: [{ type: "WalletTopUpMethods", id: "LIST" }],
            keepUnusedDataFor: 300,
        }),
        createTopUp: builder.mutation<CreateTopUpResponse, CreateTopUpRequest>({
            query: (body) => ({
                url: "/topup/create",
                method: "POST",
                body,
            }),
            invalidatesTags: [
                { type: "WalletInfo", id: "CURRENT" },
                { type: "WalletTopUpHistory", id: "LIST" },
            ],
        }),
        getTopUpHistory: builder.query<
            TopUpHistoryResponse["data"],
            { page: number; perPage: number }
        >({
            query: ({ page, perPage }) => ({
                url: "/topup/history",
                params: { page, per_page: perPage },
            }),
            providesTags: [{ type: "WalletTopUpHistory", id: "LIST" }],
            keepUnusedDataFor: 60,
        }),
        getTopUpStatus: builder.query<TopUpStatusResponse["data"], number>({
            query: (id) => `/topup/status/${id}`,
            providesTags: (_result, _err, id) => [
                { type: "WalletTopUpStatus", id },
            ],
            keepUnusedDataFor: 30,
        }),
        cancelTopUp: builder.mutation<{ success?: boolean }, { id: number }>({
            query: ({ id }) => ({
                url: `/topup/cancel/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: (_result, _error, { id }) => [
                { type: "WalletTopUpHistory", id: "LIST" },
                { type: "WalletTopUpStatus", id },
            ],
        }),
        getAdminPendingCardPayments: builder.query<PendingCardPaymentsResponse, void>({
            query: () => "/admin/topup/pending-card-payments",
            providesTags: [{ type: "AdminPendingCardPayments", id: "LIST" }],
        }),
        confirmCardPayment: builder.mutation<
            { success?: boolean },
            ConfirmCardPaymentRequest
        >({
            query: (body) => ({
                url: "/admin/topup/confirm-card-payment",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "AdminPendingCardPayments", id: "LIST" }],
        }),
        getAdminBalanceInfo: builder.query<BalanceInfo, void>({
            query: () => "/admin/topup/balance-info",
            providesTags: [{ type: "AdminBalanceInfo", id: "CURRENT" }],
        }),
        updateDepositAddress: builder.mutation<
            { success?: boolean },
            UpdateDepositAddressRequest
        >({
            query: (body) => ({
                url: "/admin/topup/update-deposit-address",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "AdminBalanceInfo", id: "CURRENT" }],
        }),
        confirmCryptoPayment: builder.mutation<
            { success?: boolean },
            ConfirmCryptoPaymentRequest
        >({
            query: (body) => ({
                url: "/admin/topup/confirm-crypto-payment",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "AdminPendingCardPayments", id: "LIST" }],
        }),
        getAdminRussiaPendingTopUps: builder.query<
            AdminRussiaPendingResponse,
            void
        >({
            query: () => "/admin/topup/russia/pending",
            providesTags: [{ type: "AdminRussiaTopUps", id: "LIST" }],
        }),
        confirmAdminRussiaTopUp: builder.mutation<{ success?: boolean }, number>({
            query: (id) => ({
                url: `/admin/topup/russia/confirm/${id}`,
                method: "POST",
            }),
            invalidatesTags: [{ type: "AdminRussiaTopUps", id: "LIST" }],
        }),
        cancelAdminRussiaTopUp: builder.mutation<
            { success?: boolean },
            { id: number; reason?: string }
        >({
            query: ({ id, reason }) => ({
                url: `/admin/topup/russia/cancel/${id}`,
                method: "POST",
                body: { reason },
            }),
            invalidatesTags: [{ type: "AdminRussiaTopUps", id: "LIST" }],
        }),
        getRussiaHands: builder.query<RussiaHandsResponse, void>({
            query: () => "/admin/russia-hands",
            providesTags: [{ type: "RussiaHands", id: "LIST" }],
        }),
        getRussiaHand: builder.query<RussiaHandResponse, number>({
            query: (id) => `/admin/russia-hands/${id}`,
            providesTags: (_result, _error, id) => [
                { type: "RussiaHands", id },
            ],
        }),
        createRussiaHand: builder.mutation<
            { success?: boolean },
            CreateRussiaHandRequest
        >({
            query: (body) => ({
                url: "/admin/russia-hands",
                method: "POST",
                body,
            }),
            invalidatesTags: [{ type: "RussiaHands", id: "LIST" }],
        }),
        updateRussiaHand: builder.mutation<
            { success?: boolean },
            { id: number; data: UpdateRussiaHandRequest }
        >({
            query: ({ id, data }) => ({
                url: `/admin/russia-hands/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: [{ type: "RussiaHands", id: "LIST" }],
        }),
        deleteRussiaHand: builder.mutation<{ success?: boolean }, number>({
            query: (id) => ({
                url: `/admin/russia-hands/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: [{ type: "RussiaHands", id: "LIST" }],
        }),
        getHandlerPendingPayments: builder.query<
            HandlerPendingPaymentsResponse["data"],
            void
        >({
            query: () => "/handler/pending-payments",
            providesTags: [{ type: "HandlerPendingPayments", id: "CURRENT" }],
            keepUnusedDataFor: 30,
        }),
        getHandlerBalanceInfo: builder.query<HandlerBalanceInfo, void>({
            query: () => "/handler/balance-info",
            providesTags: [{ type: "HandlerBalanceInfo", id: "CURRENT" }],
            keepUnusedDataFor: 300,
        }),
        confirmHandlerPayment: builder.mutation<
            ConfirmHandlerPaymentResponse,
            ConfirmHandlerPaymentRequest
        >({
            query: (body) => ({
                url: "/handler/confirm-payment",
                method: "POST",
                body,
            }),
            invalidatesTags: [
                { type: "HandlerPendingPayments", id: "CURRENT" },
                { type: "HandlerBalanceInfo", id: "CURRENT" },
            ],
        }),
        getUserStats: builder.query<
            UserStatsResponse["data"],
            { show: number; type: number; sort: number; page: number }
        >({
            query: ({ show, type, sort, page }) => ({
                url: "/stats/user",
                params: { show, type, sort, page },
            }),
            providesTags: [{ type: "UserStats", id: "LIST" }],
            keepUnusedDataFor: 60,
        }),
        getSummaryStats: builder.query<SummaryStats, void>({
            query: () => "/stats/summary",
            providesTags: [{ type: "SummaryStats", id: "CURRENT" }],
            keepUnusedDataFor: 300,
        }),
        getCurrencyStats: builder.query<CurrencyStatsResponse["data"], void>({
            query: () => "/stats/currency",
            providesTags: [{ type: "CurrencyStats", id: "CURRENT" }],
            keepUnusedDataFor: 300,
        }),
    }),
    overrideExisting: false,
});

type MutationOptions<TArg = any, TResult = any> = {
    onSuccess?: (data: TResult, variables: TArg) => void;
    onError?: (error: unknown, variables: TArg) => void;
};

const adaptMutationHook = <TArg = unknown, TResult = unknown>(
    hook: () => readonly [(arg: TArg) => any, any]
) => {
    return () => {
        const [trigger, result] = hook();

        const mutate = (arg: TArg, options?: MutationOptions<TArg, TResult>) => {
            const promise = trigger(arg);
            promise
                .unwrap()
                .then((data: TResult) => {
                    options?.onSuccess?.(data, arg);
                })
                .catch((error: unknown) => {
                    options?.onError?.(error, arg);
                });

            return promise;
        };

        const mutateAsync = (arg: TArg) => trigger(arg).unwrap();

        return {
            ...result,
            mutate,
            mutateAsync,
            isPending: result.isLoading ?? false,
        };
    };
};

const {
    useGetWalletInfoQuery,
    useWithdrawMutation,
    useSendTelegramCodeMutation,
    useTransferMutation,
    useRaiseStatusMutation,
    useExchangeMutation,
    usePayMembershipMutation,
    usePayStarProgramMutation,
    useGetTopUpMethodsQuery,
    useCreateTopUpMutation,
    useGetTopUpHistoryQuery,
    useGetTopUpStatusQuery,
    useCancelTopUpMutation,
    useGetAdminPendingCardPaymentsQuery,
    useConfirmCardPaymentMutation,
    useGetAdminBalanceInfoQuery,
    useUpdateDepositAddressMutation,
    useConfirmCryptoPaymentMutation,
    useGetAdminRussiaPendingTopUpsQuery,
    useLazyGetAdminRussiaPendingTopUpsQuery,
    useConfirmAdminRussiaTopUpMutation,
    useCancelAdminRussiaTopUpMutation,
    useGetRussiaHandsQuery,
    useGetRussiaHandQuery,
    useCreateRussiaHandMutation,
    useUpdateRussiaHandMutation,
    useDeleteRussiaHandMutation,
    useGetHandlerPendingPaymentsQuery,
    useGetHandlerBalanceInfoQuery,
    useConfirmHandlerPaymentMutation,
    useGetUserStatsQuery,
    useGetSummaryStatsQuery,
    useGetCurrencyStatsQuery,
    useLazyGetAdminPendingCardPaymentsQuery,
} = walletApi;

export const useWalletInfo = () =>
    useGetWalletInfoQuery(undefined, {
        refetchOnReconnect: true,
    });

export const useWithdraw = adaptMutationHook(useWithdrawMutation);
export const useSendTelegramCode = adaptMutationHook(useSendTelegramCodeMutation);
export const useTransfer = adaptMutationHook(useTransferMutation);
export const useRaiseStatus = adaptMutationHook(useRaiseStatusMutation);
export const useExchange = adaptMutationHook(useExchangeMutation);
export const usePayMembership = adaptMutationHook(usePayMembershipMutation);
export const usePayStarProgram = adaptMutationHook(usePayStarProgramMutation);
export const useTopUpMethods = () => useGetTopUpMethodsQuery();
export const useCreateTopUp = adaptMutationHook(useCreateTopUpMutation);
export const useTopUpHistory = (page = 1, perPage = 20) =>
    useGetTopUpHistoryQuery({ page, perPage });
export const useTopUpStatus = (id?: number) =>
    useGetTopUpStatusQuery(id as number, { skip: !id });
export const useCancelTopUp = adaptMutationHook(useCancelTopUpMutation);
export const usePendingCardPayments = () =>
    useGetAdminPendingCardPaymentsQuery(undefined, { skip: true });
export const useLazyPendingCardPayments = () =>
    useLazyGetAdminPendingCardPaymentsQuery();
export const useConfirmCardPayment = adaptMutationHook(
    useConfirmCardPaymentMutation
);
export const useBalanceInfo = () => useGetAdminBalanceInfoQuery();
export const useUpdateDepositAddress = adaptMutationHook(
    useUpdateDepositAddressMutation
);
export const useConfirmCryptoPayment = adaptMutationHook(
    useConfirmCryptoPaymentMutation
);
export const useAdminRussiaPendingTopUps = () =>
    useGetAdminRussiaPendingTopUpsQuery();
export const useLazyAdminRussiaPendingTopUps = () =>
    useLazyGetAdminRussiaPendingTopUpsQuery();
export const useAdminRussiaConfirmTopUp = adaptMutationHook(
    useConfirmAdminRussiaTopUpMutation
);
export const useAdminRussiaCancelTopUp = adaptMutationHook(
    useCancelAdminRussiaTopUpMutation
);
export const useRussiaHands = () => useGetRussiaHandsQuery();
export const useRussiaHand = (id?: number) =>
    useGetRussiaHandQuery(id as number, { skip: !id });
export const useCreateRussiaHand = adaptMutationHook(useCreateRussiaHandMutation);
export const useUpdateRussiaHand = adaptMutationHook(useUpdateRussiaHandMutation);
export const useDeleteRussiaHand = adaptMutationHook(useDeleteRussiaHandMutation);
export const useHandlerPendingPayments = () =>
    useGetHandlerPendingPaymentsQuery();
export const useHandlerBalanceInfo = () =>
    useGetHandlerBalanceInfoQuery();
export const useConfirmHandlerPayment = adaptMutationHook(
    useConfirmHandlerPaymentMutation
);
export const useUserStats = (
    show = 200,
    type = 0,
    sort = 100,
    page = 1,
) => useGetUserStatsQuery({ show, type, sort, page });
export const useSummaryStats = () => useGetSummaryStatsQuery();
export const useCurrencyStats = () => useGetCurrencyStatsQuery();
